import { ProductApiRoutes } from "../api";
export class ProductApi {
    constructor(api) {
        this.api = api;
    }
    api;
    getProducts() {
        return this.api.get(ProductApiRoutes.GetProductList);
    }
    getProductReviewAvatar(url, progressCallback, imageLoadCallback) {
        const endpoint = url.substring(url.lastIndexOf("/api") + 4);
        this.api.getProgress(endpoint, { responseType: "blob" }, (progress) => {
            progressCallback(progress);
        }, (data) => {
            imageLoadCallback(data);
        });
    }
}
